
<template>
  <div class="yt-div-edit"
    contenteditable="plaintext-only"
    @input="changeDivText($event)"
    @focus="divFocus"
    @blur="divBlur"
    v-html="parseText()">
  </div>
</template>
 
<script>
  import emojiParser from 'wechat-emoji-parser'
  export default {
    name: 'ytDivEdit',
    data() {
      return {
        editText: ""
      }
    },
    props: {
      value: {
        type: [String, Number],
        default: ""
      }
    },
    created() {
      this.editText = this.value
    },
    methods: {
      // 文本改变时事件
      changeDivText(event) {
        this.editText = event.target.innerHTML
      },
      divFocus() {
        this.editText = this.value
      },
      divBlur() {
        this.$emit("input", this.editText)
      },

      parseText() {
        const { value } = this
        if (!value) return
        const html = emojiParser(value).replace(/<img src/g, '<img style="width:18px;height:18px;" src').replace(/\n/g,'<br/>')
        return html
      }
    }
  }
</script>

<style lang="less" scoped>
.yt-div-edit {
    width: 100%;
    height: 200px;
    display: flex;
}
</style>